import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'lib-portal-login',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatCardModule],
  templateUrl: './portal-login.component.html'
})
export class PortalLoginComponent {
  title = input.required<string>();
  subtitle = input<string>('');
  login = output<void>();
}
